import {
  BusinessRedemptionReportResponse,
  QueryBusinessRedemptionReportArgs,
  UserSavingsResponse,
  QueryUserSavingsArgs,
  QueryReportingBusinessOverviewArgs,
  ReportingBusinessOverview,
  UserSavingsCategories
} from "@irati/types"
import {createUseQuery} from "@irati/utils/services/apollo"

import {useDealCategoriesForCurrentPackage} from "@irati/deals/hooks"
import businessRedemptionReportQuery, {businessRedemptionReportKey} from "./services/queries/businessRedemptionReport"
import userSavingsQuery, {userSavingsKey} from "./services/queries/userSavings"
import showMaximiseUsageQuery, {showMaximiseUsageKey} from "./services/queries/showMaximiseUsage"

interface GetFullSavings {
  retrieveAllFields?: boolean
}

export const useBusinessRedemptionReport = createUseQuery<BusinessRedemptionReportResponse, QueryBusinessRedemptionReportArgs>(
  businessRedemptionReportQuery,
  {key: businessRedemptionReportKey}
)

export const useUserSavings = createUseQuery<UserSavingsResponse, QueryUserSavingsArgs & GetFullSavings>(userSavingsQuery, {
  key: userSavingsKey
})

export const useShowMaximiseUsage = createUseQuery<ReportingBusinessOverview, QueryReportingBusinessOverviewArgs>(showMaximiseUsageQuery, {
  key: showMaximiseUsageKey
})

export function useTopCategories(categories: UserSavingsCategories[], pieColors: string[], othersPieColor: string) {
  const {data} = useDealCategoriesForCurrentPackage({})
  const availableCategories: UserSavingsCategories[] = categories
    .map((obj) => {
      const matchedCategory = data?.results.find((category) => category.name === obj.category?.name)
      if (matchedCategory && obj.category) {
        return {
          ...obj,
          category: {
            ...obj.category,
            url: matchedCategory.url
          }
        }
      }
      return null as any
    })
    .filter(Boolean)

  const topFiveCategories = Array.from(availableCategories)
    .sort((a, b) => b.redemptions - a.redemptions)
    .slice(0, 5)

  const otherRedemptions = availableCategories
    .sort((a, b) => b.redemptions - a.redemptions)
    .slice(5)
    .reduce((acc, key) => acc + key.redemptions, 0)

  const pieChartData = topFiveCategories.map((c, index) => ({
    value: c.redemptions,
    name: c?.category?.name,
    url: c?.category?.url,
    color: pieColors[index]
  }))

  if (otherRedemptions > 0) {
    pieChartData.push({value: otherRedemptions, name: "Others", color: othersPieColor, url: null})
  }

  return {pieChartData}
}
